export default {
  GET_CHECKOUT_ARCHIVE: 'GET_CHECKOUT_ARCHIVE',
  GET_CHECKOUT_ARCHIVE_LOADING: 'GET_CHECKOUT_ARCHIVE_LOADING',
  GET_CHECKOUT_ARCHIVE_SUCCESS: 'GET_CHECKOUT_ARCHIVE_SUCCESS',
  GET_CHECKOUT_ARCHIVE_FAILED: 'GET_CHECKOUT_ARCHIVE_FAILED',
  GET_CHECKOUT_ARCHIVE_REJECT: 'GET_CHECKOUT_ARCHIVE_REJECT',

  GET_RESERVES_CHECKOUT_ARCHIVE: 'GET_RESERVES_CHECKOUT_ARCHIVE',
  GET_RESERVES_CHECKOUT_ARCHIVE_LOADING: 'GET_RESERVES_CHECKOUT_ARCHIVE_LOADING',
  GET_RESERVES_CHECKOUT_ARCHIVE_SUCCESS: 'GET_RESERVES_CHECKOUT_ARCHIVE_SUCCESS',
  GET_RESERVES_CHECKOUT_ARCHIVE_FAILED: 'GET_RESERVES_CHECKOUT_ARCHIVE_FAILED',
  GET_RESERVES_CHECKOUT_ARCHIVE_REJECT: 'GET_RESERVES_CHECKOUT_ARCHIVE_REJECT',

  GET_CHECKOUT_ARCHIVE_DETAILS: 'GET_CHECKOUT_ARCHIVE_DETAILS',
  GET_CHECKOUT_ARCHIVE_DETAILS_LOADING: 'GET_CHECKOUT_ARCHIVE_DETAILS_LOADING',
  GET_CHECKOUT_ARCHIVE_DETAILS_SUCCESS: 'GET_CHECKOUT_ARCHIVE_DETAILS_SUCCESS',
  GET_CHECKOUT_ARCHIVE_DETAILS_FAILED: 'GET_CHECKOUT_ARCHIVE_DETAILS_FAILED',
  GET_CHECKOUT_ARCHIVE_DETAILS_REJECT: 'GET_CHECKOUT_ARCHIVE_DETAILS_REJECT',
};
